/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DeleteInviteOptions, DeleteInviteResponses } from '../../models/DeleteInvite'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Delete an invite within this org by id.
 * @summary Delete Invite
 * {@link /org/invite/:invite_id}
 */
export function deleteInvite<ThrowOnError extends boolean = true>(options: Options<DeleteInviteOptions, ThrowOnError>): Promise<UnwrappedResult<DeleteInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/org/invite/{invite_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DeleteInviteResponses, ThrowOnError>>
}
